import { render } from "./warning-cod-retail.vue?vue&type=template&id=57792d2f&ts=true"
import script from "./warning-cod-retail.vue?vue&type=script&lang=ts"
export * from "./warning-cod-retail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__